class MFRProductColorSelector {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      mainGallery: "#main-gallery",
      colorSelector: ".multi-select-option",
      beforeImage: ".before-image",
      afterImage: ".after-image"
    }

    this.counters = {
      minQuantity: 4,
      maxQuantity: 10
    }

    this.init()
  }

  init() {
    this.$colorSelector = this.$element.find(this.selectors.colorSelector)
    this.$beforeImage = this.$element.find(this.selectors.beforeImage);
    this.$afterImage = this.$element.find(this.selectors.afterImage);

    this.__handleInitSubImagesLightGallery(false)
    this.__handleColorSelectorOnMouseEvent()
  }

  __handleInitSubImagesLightGallery(triggered) {
    if (!window.product_images) return

    this.$mainGallery = document.getElementById("main-gallery");

    if(!this.$mainGallery) return;

    const data = triggered ? window.product_images_selected : window.product_images;
    const { before_image_title, before_image_file_master, before_image_file_thumbnail, after_image_title, after_image_file_master, after_image_file_thumbnail } = data

    this.$lightGallery = window.lightGallery(this.$mainGallery, {
      dynamic: true,
      plugins: [lgZoom, lgThumbnail],
      download: false,
      hideScrollbar: true,
      speed: 500,
      actualSize: false,
      zoomFromOrigin: false,
      showZoomInOutIcons: true,
      dynamicEl: [
        {
          src: after_image_file_master,
          thumb: after_image_file_thumbnail,
          subHtml: `<div class="lightGallery-captions">${after_image_title}</div>`
        },
        {
          src: before_image_file_master,
          thumb: before_image_file_thumbnail,
          subHtml: `<div class="lightGallery-captions">${before_image_title}</div>`
        }
      ]
    })

    this.$mainGallery.addEventListener("click", () => {
      this.$lightGallery.openGallery(0)
    })
  }


  __handleColorSelectorOnMouseEvent() {
    const currentBefore = this.$beforeImage.find("img");
    const currentAfter = this.$afterImage.find("img");
    const before = this.$beforeImage.find("div");
    const after = this.$afterImage.find("div");
    const object = this;

    this.$colorSelector.on("click mouseover", function (event) {
      const beforeImage = $(this).data("before-image");
      const afterImage = $(this).data("after-image");
      const beforeTitle = $(this).data("before-title");
      const afterTitle = $(this).data("after-title");
      const name = $(this).data("name");
      const index = $(this).data("index");

      const classname = event.type === "click" ? "selected" : "variant-preview";

      object.$beforeImage.find(".image-cover:not(.variant-selector, .selected)").hide();
      object.$afterImage.find(".image-cover:not(.variant-selector, .selected)").hide();

      before.prepend(`<image src="${beforeImage}" style="${currentBefore.attr("style")}" data-index="${index}" class="image-cover lozad ${classname}" width="800">`);
      after.prepend(`<image src="${afterImage}" style="${currentAfter.attr("style")}" data-index="${index}" class="image-cover lozad ${classname}" width="800">`);

      before.find(".image-cover[data-index=" + index + "]").css("display", "");
      after.find(".image-cover[data-index=" + index + "]").css("display", "");

      if (event.type === "click") {
        window.product_images_selected = {
          before_image_title: beforeTitle,
          before_image_file_master: beforeImage,
          before_image_file_thumbnail: beforeImage,
          after_image_title: afterTitle,
          after_image_file_master: afterImage,
          after_image_file_thumbnail: afterImage
        }

        object.__handleInitSubImagesLightGallery(true)

        $(".accordion .multi-select-option.is-selected").removeClass("is-selected");
        $(this).addClass("is-selected");
        $("#selected-color").html(`<li>${name}</li>`);
      }
    });

    this.$colorSelector.on("mouseleave", function () {
      if (object.$element.find(".multi-select-option.is-selected").length === 0) {
        object.$beforeImage.find(".image-cover:not(.variant-selector, .selected)").show();
        object.$afterImage.find(".image-cover:not(.variant-selector, .selected)").show();
        object.__handleInitSubImagesLightGallery(false);
      }

      $("#main-gallery").find(".variant-preview").remove();
    });
  }
}